export default __webpack_public_path__ + "static/media/gallery_01.25829e5f.jpg";